export const theme = {
  colors: {
    bg: '#141414',
    bgCard: '#1e1e1e',
    bgCardHover: '#242424',
    bgHeader: '#000000',
    border: '#2a2a2a',
    borderHover: '#444444',
    textPrimary: '#f0f0f0',
    textSecondary: '#888888',
    textMuted: '#555555',
    textDark: '#000000',
    accent: '#F5C518',
    white: '#ffffff',
    divider: '#222222',
  },
  fonts: {
    size: {
      xs: '11px',
      sm: '12px',
      base: '13px',
      lg: '14px',
      xl: '26px',
    }
  }
};